/* eslint-disable prettier/prettier */
import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    productsOrServices: {},
    productOrServiceState: {},
    isLoadingTable: false,
    showCreateOrEditModal: false,
    showDeleteModal: false
}

const mutations = {
    getPaginatedData(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/productsorservices/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            response.data.data.forEach(d => {
                d.dateCreated = moment(d.dateCreated).format('MM/DD/YYYY HH:mm')
                d.salesPrice = d.salesPrice ? numeral(d.salesPrice).format('0,0.00') : null
                d.cost = d.cost ? numeral(d.cost).format('0,0.00') : null
            })
            state.productsOrServices = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.productOrServiceState) {
            state.productOrServiceState = payload.productOrServiceState
        } else {
            state.productOrServiceState = {}
        }
    },
    openCreateEditModal(state, payload) {
        state.showCreateOrEditModal = payload.showCreateOrEditModal
        if (payload.productOrServiceState) {
            state.productOrServiceState = payload.productOrServiceState
        } else {
            state.productOrServiceState = {}
        }
    },
    clearSelectedPurchaseOrderState(state, payload) {
        if (payload.isClear) {
            state.productOrServiceState = {}
        }
    }
}

const actions = {
    getPaginatedData({
        commit
    }, payload) {
        commit('getPaginatedData', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    },
    openCreateEditModal({
        commit
    }, payload) {
        commit('openCreateEditModal', payload)
    },
    clearSelectedPurchaseOrderState({
        commit
    }, payload) {
        commit('clearSelectedPurchaseOrderState', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}